import { AI_AGENT_SERVICE_STORE_CONFIGS } from "@intrasync/ai-agent";
import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * AI Agent Module Service Stores
 *
 * Sourced from `@intrasync/ai-agent` (`AI_AGENT_SERVICE_STORE_CONFIGS`, which is
 * AI_AGENT_CORE_SERVICE_STORES + AI_AGENT_FEATURE_SERVICE_STORES): agents,
 * conversations, messages, runs, prompts, tools, tool-invocations,
 * knowledge-bases, documents, trace-spans.
 *
 * ServiceStore registration is first-wins/idempotent (see
 * StoreRegistry.registerServiceStore), so names another module already
 * registers with richer config are filtered out here. Collision check at wiring
 * time found none — every name above is new — so the set is empty; populate it
 * if a future collision arises.
 */
const STORES_OWNED_BY_OTHER_MODULES = new Set<string>([]);

export const aiAgentStores: ServiceStoreConfig[] = (
  AI_AGENT_SERVICE_STORE_CONFIGS as unknown as ServiceStoreConfig[]
).filter((store) => !STORES_OWNED_BY_OTHER_MODULES.has(store.name));
